import { render, staticRenderFns } from "./FortnoxInvoices.vue?vue&type=template&id=f19da72c"
import script from "./FortnoxInvoices.vue?vue&type=script&lang=ts"
export * from "./FortnoxInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports